<app-header></app-header>
<div class="container">
    <app-progress-bar></app-progress-bar>
    <router-outlet></router-outlet>
    <app-navigation></app-navigation>

    <!-- <app-scroller-mobile></app-scroller-mobile> -->
    <app-spinner *ngIf="isSpinnerVisible"></app-spinner>
</div>
<app-footer></app-footer>
